var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthFailure',{scopedSlots:_vm._u([{key:"textSlot",fn:function(){return [_c('h2',{staticStyle:{"max-width":"750px"}},[_vm._v("У вас нет доступа к данному разделу или сайту."),_c('br'),_vm._v("Пожалуйста, авторизуйтесь под другой учетной записью")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }